










import Vue from 'vue'
export default Vue.extend({
    props: {
        link: {
            type: String,
            required: true
        }
    },
    mounted() {
        this.insertChatbot()
    },
    beforeDestroy() {
        this.destroyChatbot()
    },
    methods: {
        destroyChatbot(): void {
            document.getElementById('msgdsk-chatbot-content')?.remove()
        },
        insertChatbot(): void {
            //  Get our head tag
            const head = document.getElementsByTagName('head')[0]

            //  Create a new script tag for our chatbot
            const script = document.createElement('script')

            //  Add our chatbot to the script tag
            script.type = 'text/javascript'
            script.src = this.link

            //  Insert the script tag into our head tag so it will display chatbot
            head.appendChild(script)
        }
    }
})
